<template>
  <div class="pt-4 width-100 px-4" v-if="me && loan">
    <b class="font-weight-black">대출 정보</b>
    <table class="my-2 width-100">
      <tr>
        <td>만기일</td>
        <td>
          <p class="mb-1">대출금 지급일로부터</p>
          <ContractAgreeInput
            ref="period"
            suffix="일"
            :placeholder="loan.offer.periodInDays"
            :isAgree.sync="agreeForm.period"
            @update:isAgree="navigateNextInput"
          />
        </td>
      </tr>
      <tr>
        <td>대출 금액</td>
        <td>
          <ContractAgreeInput
            ref="amount"
            suffix="원"
            :placeholder="loan.amount"
            :isAgree.sync="agreeForm.amount"
            @update:isAgree="navigateNextInput"
          />
        </td>
      </tr>
      <tr>
        <td>대출실행금액</td>
        <td>
          카드매출, (주)우아한형제들 등 배달매출에 의해 자동 산정(자동산정된 금원한도내 웹페이지/앱
          상에서 본인이 신청한 금액)
        </td>
      </tr>
      <tr>
        <td>상환방식</td>
        <td>원금분할 또는 일매출의 10%비율로 상환</td>
      </tr>
    </table>

    <ContractAgreeButton
      description="대출 정보에 대한 내용에"
      btn-text="확인함"
      :isAgree.sync="agreeForm.loanInfo"
      ref="loanInfo"
      @update:isAgree="navigateNextInput"
    />

    <p class="mt-4 mb-1 font-weight-bold">정상이율</p>
    <div class="mb-2">
      <ContractAgreeInput
        prefix="연"
        suffix="%"
        :placeholder="isPreview ? '' : (loan.offer.interestRate * 100).toFixed(1)"
        :isAgree.sync="agreeForm.interestRate"
        ref="interestRate"
        @update:isAgree="navigateNextInput"
      />
    </div>
    <p class="mt-4 mb-1 font-weight-bold">투자고객 리워드</p>
    <div class="mb-2">
      <ContractAgreeInput
        prefix="대출 금액의"
        suffix="%"
        :placeholder="isPreview ? '' : (0.01 * 100).toFixed(1)"
        :isAgree.sync="agreeForm.rewardFeeRate"
        ref="rewardFeeRate"
        @update:isAgree="navigateNextInput"
      />
    </div>
    <p class="mb-1 font-weight-bold">연체이율</p>
    <div class="mb-2">
      <ContractAgreeInput
        prefix="연"
        suffix="%"
        :placeholder="isPreview ? '' : (loan.offer.overdueInterestRate * 100).toFixed(1)"
        :isAgree.sync="agreeForm.overdueInterestRate"
        ref="overdueInterestRate"
        @update:isAgree="navigateNextInput"
      />
    </div>
    <p class="mb-1 font-weight-bold">수수료율(부가세 포함)</p>
    <div class="mb-3">
      <ContractAgreeInput
        prefix="대출 금액의"
        suffix="%"
        :placeholder="isPreview ? '' : (loan.offer.commissionRate * 100).toFixed(2)"
        :isAgree.sync="agreeForm.commissionRate"
        ref="commissionRate"
      />
    </div>
    <p class="mb-1 font-weight-bold">
      중도상환수수료 (단, 리워드 제공된 금원은 중도상환수수료로 대체될 수 있음)
    </p>
    <div class="mb-3">
      <ContractAgreeInput
        prefix="대출 금액의"
        suffix="%"
        :placeholder="isPreview ? '' : (0.01 * 100).toFixed(1)"
        :isAgree.sync="agreeForm.earlyRepaymentFee"
        ref="earlyRepaymentFee"
      />
    </div>

    <ul class="ml-n2 mb-4 color--nice-grey font-size--14">
      <li>현행 금융이자 보호에 관한 법률에 따른 최고이자율은 연 20%입니다.</li>
      <li>부채증명서 발급 요청 시 발급 비용은 10,000원 입니다.</li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import checkAgreeMixin from './checkAgreeMixin'
import { toPercentage } from '@/util/mathUtil'

export default {
  components: {
    ContractAgreeButton: () => import('@/components/loan/contract/input/ContractAgreeButton.vue'),
    ContractAgreeInput: () => import('@/components/loan/contract/input/ContractAgreeInput.vue'),
  },
  mixins: [checkAgreeMixin],
  props: ['loan'],
  data() {
    return {
      agreeForm: {
        period: false,
        amount: false,
        loanInfo: false,
        interestRate: false,
        rewardFeeRate: false,
        overdueInterestRate: false,
        commissionRate: false,
        earlyRepaymentFee: false,
      },
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    isPreview() {
      return this.loan?.__preview === true
    },
    /**
     * 상환비율
     */
    repaymentRatio() {
      return this.loan.offer.repaymentRatio ? toPercentage(this.loan.offer.repaymentRatio, 0) : 10
    },
  },
  methods: {
    toPercentage,
    /**
     * 다음 단계 포커싱
     * @param {*} isAgree 이전 단계 완료 여부
     */
    navigateNextInput(isAgree) {
      if (!isAgree) return

      const disagree = this.findDisagree()
      if (!disagree) return

      const refs = this.$refs?.[disagree]?.$refs
      if (refs?.input) {
        refs.input.focus()
      } else if (refs?.button) {
        this.$refs?.[disagree]?.$el?.scrollIntoView(true, { behavior: 'smooth' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
table tr {
  td:first-of-type {
    text-align: center;
  }
}

ul li {
  list-style-type: '* ';
  list-style-position: outside;
}
</style>
